import { DATA_API_SERVICE } from "@/appConfig";
import sortBy from "lodash/sortBy";
import API from "@/api/api";
import NotificationConfig, { NotificationConfigAPIResponse } from "@/classes/notificationConfig";

async function findAll() {
  try {
    const notificationItemsResponse = await API.get<NotificationConfigAPIResponse[]>(`${DATA_API_SERVICE}/config`);
    return sortBy(
      notificationItemsResponse.data.map(item => NotificationConfig.fromAPIResponse(item)),
      item => item.createdAt
    ).reverse();
  } catch (e) {
    return [];
  }
}

async function saveConfig(notificationConfig: NotificationConfig) {
  if (notificationConfig.id === "") return createConfig(notificationConfig);
  return updateConfig(notificationConfig);
}

async function createConfig(notificationConfig: NotificationConfig) {
  return API.post(`${DATA_API_SERVICE}/config`, notificationConfig);
}

async function updateConfig(notificationConfig: NotificationConfig) {
  return API.put(`${DATA_API_SERVICE}/config/${notificationConfig.id}`, notificationConfig);
}

async function removeConfig(id: string) {
  return API.delete(`${DATA_API_SERVICE}/config/${id}`);
}

const APINotificationConfig = {
  findAll,
  removeConfig,
  saveConfig
};

export default APINotificationConfig;
